import PropTypes from 'prop-types'
import { Typography, MenuItem } from '@mui/material'

import { getFieldProps } from '../../../../common/formProps'
import useTranslations from '../../../../i18n/useTranslations'
import Checkbox from '../../../../ui/components/checkbox'
import Select from '../../../../ui/components/select'

import useStatusCodeFilterOptions from '../../useStatusCodeFilterOptions'

import styles from './styles'

const StatusCode = ({
  values,
  fieldErrors,
  touched,
  disabledFilterByStatusCode,
  handleChange,
}) => {
  const t = useTranslations()

  const options = useStatusCodeFilterOptions(statusCode =>
    values.statusCode.includes(statusCode),
  )

  const getRenderValue = selected => {
    const selectedValues = disabledFilterByStatusCode ? [] : selected
    return selectedValues
      .map(code => options.find(option => option.id === code)?.label)
      .join(', ')
  }

  return (
    <Select
      labelId="statusCode"
      label={
        <Typography variant="h4bold">{t('noun:shippingStatusCode')}</Typography>
      }
      id="statusCode"
      disabled={disabledFilterByStatusCode}
      multiple
      {...getFieldProps('statusCode', values, fieldErrors, touched, t)}
      onChange={event => {
        const value = event.target.value
        handleChange({
          target: {
            name: 'statusCode',
            value: options
              .filter(option => value.includes(option.id))
              .map(option => option.id),
          },
        })
      }}
      renderValue={getRenderValue}
    >
      {options.map(({ id, label, checked }) =>
        id.includes('separator') ? (
          <Typography key={id} sx={styles.separator}>
            {label}
          </Typography>
        ) : (
          <MenuItem key={id} value={id} sx={styles.statusCodeItem}>
            <Checkbox checked={checked} />
            {label}
          </MenuItem>
        ),
      )}
    </Select>
  )
}
StatusCode.propTypes = {
  values: PropTypes.shape({
    statusCode: PropTypes.arrayOf(PropTypes.string.isRequired),
  }),
  fieldErrors: PropTypes.shape({
    statusCode: PropTypes.string.isRequired,
  }),
  touched: PropTypes.shape({
    statusCode: PropTypes.string,
  }),
  disabledFilterByStatusCode: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
}

export default StatusCode
